export enum enShippingType {
  FREE = '1',
  FIXED = '2',
  CORREIOS = '3',
  SHOPIARY = '4'
}
